
<template>
    <div>
        <div class="agInputGroup agInputGroupCentered">
            <label>Connection (Geometry Server):</label>
            <b-form-select 
                class="agLargeInput"
                v-model="geoInput.connection" 
                :options="connections" 
                :disabled="disableUI">
            </b-form-select>
        </div>
        <ag-sub-input
            ref="fromGeometry"
            :initText="geoInput.config.fromGeometry"
            :type="'textarea'"
            :workflow="workflow"
            :rows="5"
            :maxRows="5"
            :noResize="true"
            :label="'From Geometry:'"
            :placeholder="'e.g. {x:-13049248, y:4016899.5, spatialReference:{wkid:102100}}'"
            :disabled="disableUI">
        </ag-sub-input>
        <ag-sub-input
            ref="toGeometry"
            :initText="geoInput.config.toGeometry"
            :type="'textarea'"
            :workflow="workflow"
            :rows="5"
            :maxRows="5"
            :noResize="true"
            :label="'To Geometry:'"
            :placeholder="'e.g. {x:-13049248, y:4016899.5, spatialReference:{wkid:102100}}'"
            :disabled="disableUI">
        </ag-sub-input>
        <div class="agInputGroup agInputGroupCentered">
            <b-input-group class="agInputGroup agInputGroupInline" prepend="Spatial Reference (WKID)">
                <b-input 
                    class="agSmallInput"
                    type="number" 
                    v-model="geoInput.config.sr"
                    autocomplete="false"
                    :disabled="disableUI">
                </b-input>
            </b-input-group>
            <div class="agInputGroup agInputGroupInline">
                <label>Out Units:</label>
                <b-form-select 
                class="agSmallInput"
                v-model="geoInput.config.units" 
                :options="units" 
                :disabled="disableUI">
                </b-form-select>
            </div>
        </div>
        <label class="agNote">{{`Output will be stored in field ${geoInput.shortname}.DISTANCE`}}</label>
    </div>
</template>






<script>

// components
import SubInput from "comp/ui/SubInput"

// modules

export default {
    name: "ag-geoInput-distance",
    components: {
        "ag-sub-input": SubInput,
    },
    props:{
        disableUI: Boolean,
        workflow: Object,
        geoInput: Object,
    },
    data(){
        return {
            units:[
                {value: 9003, text: "Feet"},
                {value: 9001, text: "Meters"},
                {value: 9035, text: "Miles"},
                {value: 9036, text: "Kilometers"},
                {value: 109002, text: "Yards"}
            ]
        };
    },
    computed: {

        connections() {
            var connections = [];
            var geoConnections = this.$store.getters["connStore/getGeometryConns"];
            for (var i = 0; i < geoConnections.length; i++) {
                var conn = geoConnections[i];
                var connItem = {value: conn, text: conn.name};
                connections.push(connItem);

                if(this.geoInput.connection && conn._id == this.geoInput.connection._id) {
                this.geoInput.connection = conn;
                }
          }
          return connections;
        },

    },
    watch: {
     
    },

    created() {

    },

    mounted() {
        this.reset();
    },

    methods: {



        // emitted Events


        // other

        reset() {
            // init config object if it's empty
            if (Object.keys(this.geoInput.config).length == 0) {
                this.geoInput.config = {
                    fromGeometry: null,
                    toGeometry: null,
                    sr: null,
                    units: null,
                    fields: []
                };
            }
        },

        prepareForSave() {
            this.geoInput.config.fromGeometry = this.$refs["fromGeometry"].text;
            this.geoInput.config.toGeometry = this.$refs["toGeometry"].text;
            this.geoInput.config.fields = ["DISTANCE"];

        },

         
    }
}

</script>






<style scoped lang="css">

</style>


// WEBPACK FOOTER //
// src/components/nodes/geoInputs/Distance.vue